import React, { Component, useEffect } from 'react';
import "./BenefitsSection.css";
import Curriculum from "../../src/assets/images/nfsu3.png";
import Winner from "../../src/assets/images/winner.png";
import Calendar from "../../src/assets/images/calendar.png";

export default function BenefitsSection() {
    const benefits = [
        {
            img: Winner,
            title: "Globally Recognized",
            subtitle: "Prestigious Certificate",
        },
        {
            img: Curriculum,
            title: "Evolve Curriculum",
            subtitle: "",
        },
        {
            img: Calendar,
            title: "Flexible &",
            subtitle: "Convenient schedule",
        },
    ];

    return (
        <div className="benefits-container">
            <h2 className="benefits-heading">
                <span>Unlock these benefits</span>
            </h2>
            <div className="benefits-grid">
                {benefits.map((benefit, idx) => (
                    <div key={idx} className="benefit-card">
                        <div className="benefit-icon"><img src={benefit.img} ></img></div>

                        <h3 className="benefit-title">{benefit.title}</h3>
                        {benefit.subtitle && (
                            <p className="benefit-title">{benefit.subtitle}</p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

